module.exports = __webpack_public_path__ + "img/jp.ddcf73e1.svg";